import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../service";
import {IErrorResponse, IRootState} from "../../../../types";
import {
    deletedSectors,
    deletedSectorsRestore,
    setSectors,
    setSectorsRestore,
    updateSectors
} from "./educationalSectorsSlice";
import {IEducationSectorCreate, IEducationSectorPayload} from "../types";





const GetSectors = createAsyncThunk(
    "get/sectors",
    async (_, { dispatch,rejectWithValue,getState }) => {


        try {
            const response = await request.get("/education-sectors");
            const lang = getState()  as IRootState
            const defaultLanguage = lang.languages.defaultLanguage
            dispatch(setSectors({data:response.data,defaultLanguage}));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);
const SetSectors = createAsyncThunk(
    "create/sectors",
    async ( data : IEducationSectorCreate,{rejectWithValue}) => {
        try {
            const response = await request.post("/education-sectors", data);

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);
const EditSectors = createAsyncThunk(
    "edit/sectors",
    async ( data : IEducationSectorPayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/education-sectors/${data.id}`, data);
            dispatch(updateSectors(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const DeleteSectors = createAsyncThunk(
    "delete/sectors",
    async ( id : number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/education-sectors/${id}`);

            dispatch(deletedSectors(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteSectors = createAsyncThunk(
    "get/delete/sectors",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/education-sectors/deleted-items`);

            dispatch(setSectorsRestore(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);
const RestoreDeleteSectors= createAsyncThunk(
    "restore/delete/sectors",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/education-sectors/restore/${id}`);

            dispatch(deletedSectorsRestore(id));

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


export{
    GetSectors,
    SetSectors,
    EditSectors,
    DeleteSectors,
    GetDeleteSectors,
    RestoreDeleteSectors
}